import React from 'react';
import { Toaster } from 'sonner';
import ColorPalette from './components/ColorPalette';
import BrandAssets from './components/BrandAssets';
import InternalColors from './components/InternalColors';
import Typography from './components/Typography';
export function App() {
  return <div className="min-h-screen bg-slate-50 p-6 md:p-10" data-id="element-0">
      <header className="mb-8" data-id="element-1">
        <h1 className="text-3xl font-bold text-slate-900" data-id="element-2">
          Magic Patterns Brand
        </h1>
      </header>
      <div className="mb-12" data-id="element-3">
        <BrandAssets data-id="element-4" />
      </div>
      <InternalColors data-id="element-5" />
      <Typography data-id="element-6" />

      <Toaster data-id="element-7" />
    </div>;
}